module.exports = __webpack_public_path__ + "img/setup.43e69dee.png";